import React, { useEffect } from 'react';
import Notification from '~/_base/components/notification';
import { useToast, useToastState } from '~/_base/context/toastContext';

// Regular component to show toast notifications using the notification context.
// Also checks for a server rendered alert (a div with class name 'alert') and replaces it
// with the react alert. Also places the showAlert function on the window (not sure if this is still used).
export default function Alerts() {
  const {
    errorToast,
    successToast,
    infoToast,
    warningToast,
    clearToast,
  } = useToast();
  const notificationState = useToastState();

  useEffect(() => {
    function showAlert(
      message: string,
      variantToUse: '' | 'error' | 'success' | 'info' | 'warning'
    ) {
      switch (variantToUse) {
        case 'error':
          errorToast(message);
          break;
        case 'success':
          successToast(message);
          break;
        case 'warning':
          warningToast(message);
          break;
        default:
          infoToast(message);
      }
    }

    function checkForAlertDiv() {
      const alert: any = document.getElementsByClassName('alert')[0];

      if (alert != null) {
        alert.style.display = 'none';

        setTimeout(() => {
          showAlert(
            sanitizeMessage(alert.textContent),
            calculateAlertType(alert.getAttribute('class'))
          );
        }, 500);
      }
    }

    checkForAlertDiv();
    (window as any).showAlert = showAlert;
  }, [errorToast, infoToast, successToast, warningToast]);

  function handleNotificationClose() {
    clearToast();
  }

  function sanitizeMessage(txt: string) {
    // remove the x that rails puts in as the link content to close the notification
    if (txt.trim().indexOf('x') === 0) {
      return txt.replace('x', '').trim();
    }
    return txt;
  }

  function calculateAlertType(attr: string) {
    // rails provides 3 types of notification, default to info if we can't work out which to use.
    attr = attr.replace('alert ', '');

    switch (attr) {
      case 'alert-error':
        return 'error';
      case 'alert-info':
        return 'info';
      case 'alert-success':
        return 'success';
      default:
        return 'info';
    }
  }

  return (
    <Notification
      variant={notificationState.variant}
      message={notificationState.message}
      show={notificationState.show}
      handleClose={handleNotificationClose}
    />
  );
}
